import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';
import authReducer from './authMobileReducer';
import currencyReducer from './currencyMobileReducer';
import sharedRelayVariablesReducer from './sharedRelayVariablesReducer';
import sharedIntlVariablesReducer from './sharedIntlVariablesReducer';
import filterReducer from './filterReducer';
import displayPreferenceReducer from './displayPreferenceReducer';
import measurementUnitReducer from './measurementUnitReducer';
import cartReducer from 'dibs-buyer-layout/src/reducers/cartReducer';
import headerReducer from 'dibs-buyer-layout/src/reducers/headerReducer';

/**
 * Local `app-buyer-finding` reducers that should be used across the app.
 */
export const defaultReducers = {
    authReducer,
    currencyReducer,
    relayVariables: sharedRelayVariablesReducer,
    intlVariables: sharedIntlVariablesReducer,
};

export const sbSharedReducers = {
    filters: filterReducer,
    displayPreferences: displayPreferenceReducer,
    measurementUnit: measurementUnitReducer,
};

/**
 * We're sneaky and we steal some reducers from DBL. Only used by the mobile nav. We could probably
 * not do this and just let the mobile nav create it's own store in dbl.
 */
export const dblReducers = { cart: cartReducer, header: headerReducer };

/**
 * Creates a redux store and applys additional middleware. Defaults to creating a store with all reducers.
 *
 * Shouldn't be used on responsive entry files!!! The store there is coming from the DBL.
 */
export function createReduxStore(additionalReducers = {}, state = {}) {
    const reducers = combineReducers({ ...defaultReducers, ...dblReducers, ...additionalReducers });
    return createStore(reducers, state, applyMiddleware(thunk));
}
